import React from 'react'
import PropTypes from 'prop-types'
import { withDevice, mediaQueries } from '@blazar-plugins/device'
import TextOverlay from 'components/TextOverlay'
import ParametersList from 'components/ParametersList'
import formatRelative from 'utils/date/formatRelative'
import get from 'lodash/get'
import { isValidUrl } from 'utils/url'
import { IconCheck } from 'blocket-ui'
import AdvertiserTypeSymbol from './AdvertiserTypeSymbol'
import Region from './Region'
import Category from './Category'
import StoreInfo from './StoreInfo'
import Price from '../Price'
import ListImage from '../ListImage'

import {
  Wrapper,
  Article,
  Content,
  HeartIcon,
  ImageWrapper,
  LocationTimeWrapper,
  Time,
  ParamsWrapper,
  SalesInfo,
  RemoveSavedAd,
  SubjectSymbol,
  SubjectWrapper,
  Title,
  ApplyDaysLeftLabel,
  TopInfoWrapper,
  StoreLogo,
  Notification,
  SubjectContainer,
  ExtraServiceEnabledText,
  ExtraServiceEnabledWrapper,
} from '../styled'

function ListItem({
  ad,
  device,
  url,
  isExternalLink,
  onClick,
  image,
  imageSrc,
  isSaved,
  adParams = [],
  imageBadges,
  onRemoveSavedAd,
  className,
  isNew,
  query,
  index,
}) {
  const { advertiser, job, adStatus, subject, toplistingLabel, listTime, isToplisting = false } = ad
  const isActive = adStatus === 'active'

  const getpartnerInfo = get(ad, 'partnerInfo')

  const isJobAd = getpartnerInfo && getpartnerInfo.name === 'blocket_jobb'

  const applyDaysLeftLabel = job && job.applyDaysLeftLabel && (
    <ApplyDaysLeftLabel>{job.applyDaysLeftLabel}</ApplyDaysLeftLabel>
  )

  const storeLogoUrl = get(ad, 'store.logo.url')
  const storeName = get(advertiser, 'storeName')
  const name = get(advertiser, 'name')
  const displayName = storeName || name
  const showStoreName = displayName && (advertiser.type === 'store' || advertiser.type === 'broker')
  const showStoreLogo = isToplisting && isValidUrl(storeLogoUrl)
  const showShippingEnabled = get(ad, 'parametersRaw.shippingEnabled.value') === '1'
  const showBlocketPaymentEnabled = get(ad, 'parametersRaw.blocketPaymentEnabled.value') === '1'

  return (
    <Wrapper
      className={className}
      to={url}
      external={isExternalLink}
      isActive={isActive}
      onClick={onClick}
      aria-label={subject}
    >
      <Article>
        <ImageWrapper>
          <ListImage
            image={image}
            src={imageSrc}
            alt={subject}
            objectFit={isJobAd ? 'none' : null}
            sizes={`
              ${mediaQueries.medium} 180px,
              120px
            `}
            index={index}
          >
            {imageBadges}
          </ListImage>
          {!isActive && <TextOverlay>Såld eller borttagen</TextOverlay>}
        </ImageWrapper>
        <Content>
          <LocationTimeWrapper>
            <SubjectSymbol>
              {advertiser && <AdvertiserTypeSymbol advertiserType={advertiser.type} />}
            </SubjectSymbol>
            <TopInfoWrapper>
              {device.is('large') && <Category ad={ad} query={query} />}
              {ad.location && ad.location[0].name !== 'Flera platser' && (
                <>
                  {device.is('large') && <>&nbsp;·&nbsp;</>}
                  <Region
                    query={query}
                    location={ad.location}
                    isShippingEnabled={showShippingEnabled}
                  />
                </>
              )}
            </TopInfoWrapper>
            <Time>
              {applyDaysLeftLabel}
              {toplistingLabel || formatRelative(listTime)}
            </Time>
          </LocationTimeWrapper>
          <SubjectWrapper>
            <Title to={url}>
              <SubjectContainer>{ad.subject}</SubjectContainer>{' '}
              {isNew && <Notification>Ny!</Notification>}
            </Title>
          </SubjectWrapper>
          {showShippingEnabled && (
            <ExtraServiceEnabledWrapper>
              <IconCheck width="14px" />
              <ExtraServiceEnabledText>Erbjuder frakt</ExtraServiceEnabledText>
            </ExtraServiceEnabledWrapper>
          )}
          {showBlocketPaymentEnabled && (
            <ExtraServiceEnabledWrapper>
              <IconCheck width="14px" />
              <ExtraServiceEnabledText>Erbjuder trygg betalning</ExtraServiceEnabledText>
            </ExtraServiceEnabledWrapper>
          )}
          <ParamsWrapper>
            {adParams.length > 0 && <ParametersList parameters={adParams} />}
            {isSaved && (
              <RemoveSavedAd onClick={onRemoveSavedAd}>
                <HeartIcon />
              </RemoveSavedAd>
            )}
          </ParamsWrapper>
          <SalesInfo>
            <Price price={ad.price} />
            {showStoreLogo && <StoreLogo src={storeLogoUrl} alt="store logo" />}
            {showStoreName && device.is('large') && <StoreInfo name={displayName} />}
          </SalesInfo>
        </Content>
      </Article>
    </Wrapper>
  )
}

ListItem.propTypes = {
  ad: PropTypes.object.isRequired,
  device: PropTypes.object.isRequired,
  query: PropTypes.object,
  image: PropTypes.object,
  imageSrc: PropTypes.string,
  isSaved: PropTypes.bool,
  isNew: PropTypes.bool,
  url: PropTypes.string.isRequired,
  isExternalLink: PropTypes.bool,
  onClick: PropTypes.func,
  onRemoveSavedAd: PropTypes.func,
  adParams: PropTypes.array,
  imageBadges: PropTypes.array,
  className: PropTypes.string,
  index: PropTypes.number,
}

export default withDevice(ListItem)
